var _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRectangleToolSmart = function SvgRectangleToolSmart(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6 7H22C24.8284 7 26.2426 7 27.1213 7.87868C28 8.75736 28 10.1716 28 13V25H12C9.17157 25 7.75736 25 6.87868 24.1213C6 23.2426 6 21.8284 6 19V7Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4231_26901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2756 21.6206C26.3042 21.4775 26.3185 21.406 26.3257 21.3805C26.5165 20.6987 27.483 20.6987 27.6739 21.3805C27.681 21.406 27.6953 21.4775 27.7239 21.6206C27.7377 21.6896 27.7446 21.7241 27.752 21.7556C27.9252 22.4962 28.5034 23.0745 29.244 23.2476C29.2755 23.255 29.31 23.2619 29.3791 23.2757C29.5221 23.3043 29.5936 23.3186 29.6191 23.3258C30.3009 23.5166 30.3009 24.4831 29.6191 24.674C29.5936 24.6811 29.5221 24.6954 29.3791 24.724C29.31 24.7378 29.2755 24.7447 29.244 24.7521C28.5034 24.9253 27.9252 25.5035 27.752 26.2441C27.7446 26.2756 27.7377 26.3101 27.7239 26.3792C27.6953 26.5222 27.681 26.5938 27.6739 26.6192C27.483 27.301 26.5165 27.301 26.3257 26.6192C26.3185 26.5938 26.3042 26.5222 26.2756 26.3792C26.2618 26.3101 26.2549 26.2756 26.2475 26.2441C26.0744 25.5035 25.4961 24.9253 24.7555 24.7521C24.724 24.7447 24.6895 24.7378 24.6204 24.724C24.4774 24.6954 24.4059 24.6811 24.3804 24.674C23.6986 24.4831 23.6986 23.5166 24.3804 23.3258C24.4059 23.3186 24.4774 23.3043 24.6204 23.2757C24.6895 23.2619 24.724 23.255 24.7555 23.2476C25.4961 23.0745 26.0744 22.4962 26.2475 21.7556C26.2549 21.7241 26.2618 21.6896 26.2756 21.6206Z",
    fill: "currentColor"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4231_26901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.27563 5.62052C6.30424 5.47747 6.31854 5.40594 6.32567 5.38048C6.51648 4.6987 7.48305 4.6987 7.67386 5.38048C7.68099 5.40594 7.69529 5.47747 7.7239 5.62052C7.73771 5.68957 7.74462 5.72409 7.75198 5.75556C7.92516 6.49616 8.50343 7.07443 9.24403 7.24762C9.27551 7.25498 9.31003 7.26188 9.37908 7.27569C9.52213 7.3043 9.59366 7.31861 9.61911 7.32573C10.3009 7.51655 10.3009 8.48312 9.61911 8.67393C9.59366 8.68105 9.52213 8.69536 9.37908 8.72397C9.31003 8.73778 9.27551 8.74468 9.24403 8.75204C8.50343 8.92523 7.92516 9.5035 7.75198 10.2441C7.74462 10.2756 7.73771 10.3101 7.7239 10.3792C7.69529 10.5222 7.68099 10.5938 7.67386 10.6192C7.48305 11.301 6.51648 11.301 6.32567 10.6192C6.31854 10.5938 6.30424 10.5222 6.27563 10.3792C6.26182 10.3101 6.25491 10.2756 6.24755 10.2441C6.07437 9.5035 5.4961 8.92523 4.7555 8.75204C4.72402 8.74468 4.6895 8.73778 4.62046 8.72397C4.4774 8.69536 4.40588 8.68105 4.38042 8.67393C3.69863 8.48312 3.69863 7.51655 4.38042 7.32573C4.40588 7.31861 4.4774 7.3043 4.62046 7.27569C4.6895 7.26188 4.72402 7.25498 4.7555 7.24762C5.4961 7.07443 6.07437 6.49616 6.24755 5.75556C6.25491 5.72409 6.26182 5.68957 6.27563 5.62052Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4231_26901",
    x: 20.869,
    y: 18.8691,
    width: 12.2614,
    height: 12.2617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.333333 0 0 0 0 0.192157 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4231_26901"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4231_26901",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4231_26901",
    x: 0.86908,
    y: 2.86914,
    width: 12.2614,
    height: 12.2617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.333333 0 0 0 0 0.192157 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4231_26901"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4231_26901",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRectangleToolSmart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "rectangle-tool-smart.c0a921be82f42c16dea1ecc6e63bf614.svg";